import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { NavLink, useLocation } from "react-router-dom";
import MyContext from "../MyContext";
import logoImage from "../images/mini-logo.svg";
import LogoutImage from "../images/logout.svg";
import "./DesktopNav.css";

/* ================= INTERNAL NAV ================= */
const InternalNav = ({ services, commonMinimized }) => {
  const location = useLocation();

  return (
    <div className={`internal-nav ${commonMinimized ? "minimized" : ""}`}>
      <div
        className="m-0 mt-4 d-flex justify-content-end pb-4"
        style={{ borderBottom: "1px solid #E8E2E2" }}
      >
        <button
          className="px-3 py-2"
          style={{ border: 0, borderRadius: "10px 0px 0px 10px" }}
        >
          {commonMinimized ? "🡪" : "🡨"}
        </button>
      </div>

      <div className="nav-links2 mt-4">
        {services
          ?.filter((service) => service?.service_url && service?.service_name)
          .map((service) => {
            const isActive = location.pathname === service.service_url;
            
            return (
              <NavLink
                key={service.id}
                to={service.service_url}
                className={`navlink-height ${isActive ? "internal-link" : ""}`}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={`d-flex flex-column align-items-center ${
                    commonMinimized ? "my-2 mx-3" : "m-3"
                  }`}
                >
                  {service.service_active_icon && (
                    <img
                      src={service.service_active_icon}
                      className="nav-icon"
                      width={20}
                      alt={service.service_name}
                    />
                  )}

                  {commonMinimized && (
                    <div className="nav-text text-center text-dark single-line-css">
                      {service.service_name}
                    </div>
                  )}
                </div>

                {!commonMinimized && service.service_name}
              </NavLink>
            );
          })}
      </div>
    </div>
  );
};

/* ================= MAIN NAV ================= */
const NavigationBar = ({ handleLogout, userID }) => {
  const { baseUrl, config } = useContext(MyContext);
  const location = useLocation();

  const [modules, setModules] = useState([]);
  const [commonMinimized, setCommonMinimized] = useState(
    () => JSON.parse(sessionStorage.getItem("commonMinimized")) ?? true
  );

  useEffect(() => {
    sessionStorage.setItem("commonMinimized", JSON.stringify(commonMinimized));
  }, [commonMinimized]);

  const MODULE_ORDER = [
    "Dashboard",
    "Whatsapp",
    "SMS",
    "Email",
    "Orders",
    "Inventory",
    "Developers",
    "Settings",
    "Billing",
    "Pos",
    "Support",
  ];

  useEffect(() => {
    const fetchSidebar = async () => {
      try {
        const res = await axios.post(
          `${baseUrl}/api/Entitlement/v1.0/fetchEntitlementModuleDetails`,
          { userid: userID },
          config
        );

        if (res.data.responseCode === "00") {
          const apiModules = res.data.data || [];

          const sortedModules = [...apiModules].sort((a, b) => {
            const aIndex = MODULE_ORDER.indexOf(a.module_name);
            const bIndex = MODULE_ORDER.indexOf(b.module_name);

            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;

            return aIndex - bIndex;
          });

          setModules(sortedModules);
        }
      } catch (err) {
        console.error("Sidebar API error", err);
      }
    };

    if (userID) fetchSidebar();
  }, [userID, baseUrl, config]);

  const activeModule = modules.find((module) => {

    const pathParts = location.pathname.split('/').filter(Boolean);
    const currentPath = pathParts[0] || '';
    
    const moduleUrlParts = module.module_url?.split('/').filter(Boolean) || [];
    const moduleFirstPath = moduleUrlParts[0] || '';
    
    return currentPath.toLowerCase() === moduleFirstPath.toLowerCase();
  });

  return (
    <>
      <div className="sidebar py-5 h-100">
        <div>
          <div className="logo d-flex justify-content-center mb-1 ps-2">
            <img src={logoImage} height={50} alt="Logo" />
          </div>

          {/* MODULE LIST */}
          <div className="d-flex flex-column justify-content-start">
            {modules.map((module) => {
              const moduleUrlParts = module.module_url?.split('/').filter(Boolean) || [];
              const moduleFirstPath = moduleUrlParts[0] || '';
              
              // Extract first part of current path
              const pathParts = location.pathname.split('/').filter(Boolean);
              const currentPath = pathParts[0] || '';
              
              const isActive = currentPath.toLowerCase() === moduleFirstPath.toLowerCase();

              return (
                <div key={module.id} className="nav-link-container">
                  <NavLink
                    to={module.module_url}
                    className={`d-block link navlink-height d-flex flex-column ${
                      isActive ? "active" : ""
                    }`}
                  >
                    <img
                      src={
                        isActive
                          ? module.module_selected_icon
                          : module.module_active_icon
                      }
                      width={20}
                      height={20}
                      alt={module.module_name}
                    />
                    <div className="nav-text">{module.module_name}</div>
                  </NavLink>

                  {/* INTERNAL NAV - Only show if valid services exist */}
                  {isActive && module.services?.some(s => s?.service_url && s?.service_name) && (
                    <InternalNav
                      services={module.services}
                      commonMinimized={commonMinimized}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="w-100">
          <div
            className="link cursor-pointer d-flex flex-column"
            onClick={handleLogout}
          >
            <img src={LogoutImage} width={20} alt="Logout" />
            <div className="nav-text">Logout</div>
          </div>
        </div>
      </div>

      {/* ---------- CONTENT SHIFT ---------- */}
      <div
        className={`content-nav ${
          activeModule && activeModule.services?.some(s => s?.service_url && s?.service_name)
            ? commonMinimized
              ? "content-internal-nav-open-minimized"
              : "content-internal-nav-open"
            : ""
        }`}
      />
    </>
  );
};

export default NavigationBar;